import React from 'react';
import PropTypes from 'prop-types';
import {Status} from '@fiverr/fit';
import '@fiverr/globals';
import './style.scss';

const BADGE_CASES = {
    FEATURED: 'featured',
    CHOICE: 'choice',
    PRO: 'pro',
    LIMITED: 'limited',
    HIGH_COMPLETION: 'high_completion',
    TALENT: 'talent'
};

const Badge = ({ type, className }) => {
    let badge,
        leftAlign;

    switch (type) {
        case BADGE_CASES.FEATURED:
            badge = (
                <Status classes="featured badge-hint js-badge-hint"
                    data-hint={i18n.t('badges.featured.tooltip')}>
                    {i18n.t('badges.featured.caption')}
                </Status>
            );
            break;
        case BADGE_CASES.CHOICE:
            badge = <Status classes="quality-choice">{i18n.t('badges.fiverrs_choice.caption')}</Status>;
            break;
        case 'now':
            badge = (
                <Status classes="available-now badge-hint js-badge-hint"
                    data-hint={i18n.t('badges.available_now.tooltip')}>
                    <i/> {i18n.t('badges.available_now.caption')}
                </Status>
            );
            break;
        case BADGE_CASES.PRO:
            badge = <span className="pro-badge card-badge outline badge-hint js-badge-hint" data-hint={i18n.t('badges.pro.tooltip')}/>;
            break;
        case BADGE_CASES.LIMITED:
            leftAlign = true;
            badge = (
                <Status classes="limited-edition badge-hint js-badge-hint"
                    data-hint={i18n.t('badges.limited_edition.tooltip')}>
                    {i18n.t('badges.limited_edition.caption')}
                </Status>
            );
            break;
        case BADGE_CASES.HIGH_COMPLETION:
            badge = (
                <Status classes="high-completion-rate badge-hint js-badge-hint"
                    data-hint={i18n.t('badges.very_reliable.tooltip')}>
                    <i/> {i18n.t('badges.very_reliable.caption')}
                </Status>
            );
            break;
        case BADGE_CASES.TALENT:
            leftAlign = true;
            badge = (
                <Status classes="rising-talent badge-hint js-badge-hint"
                    data-hint={i18n.t('badges.rising_talent.tooltip')}>
                    {i18n.t('badges.rising_talent.caption')}
                </Status>
            );
            break;
        default:
            break;
    }

    const classes = ['gig-badge'];
    className && classes.push(className);
    leftAlign && classes.push('left');
    type === BADGE_CASES.TALENT && classes.push('rising-talent');

    return <span className={classes.join(' ')}>{badge}</span>;
};

Badge.propTypes = {
    type: PropTypes.string
};

export default Badge;



// WEBPACK FOOTER //
// ./src/shared/badge/index.js